import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchBlogs = async () => {
  const response = await api.get("/blogs");
  return response.data;
};

export const fetchBlogPost = async (slug) => {
  const response = await api.get(`/blogs/${slug}`);
  return response.data;
};

export const createInquiry = async (payload) => {
  const response = await api.post("/inquiries", payload);
  return response.data;
};

export default api;